import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import DraggableContainer from "./draggableContainer";
import DropdownMenu from "./dropdownMenu";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import NewComponent from "./newComponent";
import Modal from "react-bootstrap/Modal";

function App() {
  const [draggables, setDraggables] = useState([]);
  const [showSettings, setShowSettings] = useState(true);
  const handleCloseSettings = () => setShowSettings(false);
  const handleShowSettings = () => setShowSettings(true);
  const [showReceiveStat, setShowReceiveStat] = useState(false);
  const handleCloseReceiveStat = () => setShowReceiveStat(false);
  const handleShowReceiveStat = () => setShowReceiveStat(true);
  const [showSendStream, setShowSendStream] = useState(false);
  const handleCloseSendStream = () => setShowSendStream(false);
  const handleShowSendStream = () => setShowSendStream(true);
  const [showRStream, setShowRStream] = useState(false);
  const handleCloseRStream = () => setShowRStream(false);
  const handleShowRStream = () => setShowRStream(true);
  const [showTimer, setShowTimer] = useState(false);
  const handleCloseTimer = () => setShowTimer(false);
  const handleShowTimer = () => setShowTimer(true);
  const [showWebRTC, setShowWebRTC] = useState(false);
  const handleCloseWebRTC = () => setShowWebRTC(false);
  const handleShowWebRTC = () => setShowWebRTC(true);
  const [showDownload, setShowDownload] = useState(true);
  const handleCloseDownload = () => setShowDownload(false);
  const handleShowDownload = () => setShowDownload(true);
  const [showInstruction, setShowInstruction] = useState(false);
  const handleCloseInstruction = () => setShowInstruction(false);
  const handleShowInstruction = () => setShowInstruction(true);

  const availablePort = () => {
    let playerNum = Number.parseInt(document.getElementById('playerNum')?.value);
    if (isNaN(playerNum)) return null;
    const used = draggables.map(d=>d.port);
    for (let i = (playerNum-1)*3+9976; i < (playerNum)*3+9976; i++ ) {
      if (!used.includes(i))
        return i;
    }
    return null;
  }

  const generateId = () => {
    return `${new Date().getTime()}-${Math.random()}`;
  };
  const addDraggable = (typ) => () => {
    // Create a new draggable component and add it to the state array
    const id = generateId();
    let port = null;
    if (typ === 'sendAudioFile' || typ === 'sendScore') {
      port = availablePort();
      if (!port) return;
    }
    const newDraggable = {
      id: id,
      port: port,
      component: (
        <NewComponent
          key={id}
          titleName={typ}
          handleHide={removeDraggable(id)}
          port={port}
          showing={true}
        ></NewComponent>
      ),
    };
    setDraggables((old) => [...old, newDraggable]);
  };
  const removeDraggable = (idToRemove) => () => {
    setDraggables((old) =>
      old.filter((draggable) => draggable.id !== idToRemove)
    );
  };

  return (
    <div className="SoundMeshWeb">
      <DropdownMenu titleName={"Add Send Component"}>
        <Dropdown.Item onClick={addDraggable("sendAudioFile")}>
          Send Audio File
        </Dropdown.Item>
        <Dropdown.Item onClick={addDraggable("sendScore")}>
          Send a Score
        </Dropdown.Item>
        <Dropdown.Item onClick={handleShowSendStream}>
          Stream Locally
        </Dropdown.Item>
        <Dropdown.Item onClick={addDraggable("WebRTCComponent")}>
          Stream Online (send & receive)
        </Dropdown.Item>
      </DropdownMenu>
      <DropdownMenu titleName={"Add Receive Component"}>
        <Dropdown.Item onClick={handleShowReceiveStat}>Stats</Dropdown.Item>
        <Dropdown.Item onClick={handleShowRStream}>Receive Stream Locally</Dropdown.Item>
        <Dropdown.Item onClick={addDraggable("WebRTCComponent")}>
          Stream Online (send & receive)
        </Dropdown.Item>
      </DropdownMenu>
      <Button
        variant="secondary"
        style={{ display: "inline-block", margin: 2 + "px" }}
        onClick={handleShowSettings}
      >
        Settings
      </Button>
      <Button
        variant="info"
        style={{ display: "inline-block", margin: 2 + "px" }}
        onClick={handleShowInstruction}
      >
        Instruction
      </Button>
      <Button
        variant="info"
        style={{ display: "inline-block", margin: 2 + "px" }}
        onClick={handleShowTimer}
      >
        Timer
      </Button>
      <Button
        variant="danger"
        style={{ display: "inline-block", margin: 2 + "px" }}
        onClick={(e) => {
          fetch("http://127.0.0.1:8080/flushAll");
        }}
      >
        FLUSH ALL
      </Button>
      <NewComponent
        titleName={"Settings"}
        showing={showSettings}
        handleHide={handleCloseSettings}
        handleShowReceiveStat={handleShowReceiveStat}
      />
      <NewComponent
        titleName={"receiveStatLights"}
        showing={showReceiveStat}
        handleHide={handleCloseReceiveStat}
      />
      {draggables.map((newComponent) => (
        <React.Fragment key={newComponent.id}>
          {newComponent.component}
        </React.Fragment>
      ))}
      <NewComponent
        titleName={'PleaseDownloadComponent'}
        showing={showDownload}
        handleHide={handleCloseDownload}
      />
      <NewComponent
        titleName={'StreamReceiveComponent'}
        showing={showRStream}
        handleHide={handleCloseRStream}
      />
      <NewComponent
        titleName={'StreamSendComponent'}
        showing={showSendStream}
        handleHide={handleCloseSendStream}
      />
      <NewComponent
        titleName={'TimerComponent'}
        showing={showTimer}
        handleHide={handleCloseTimer}
      />
      <NewComponent
        titleName={'InstructionComponent'}
        showing={showInstruction}
        handleHide={handleCloseInstruction}
      />
      {/* <NewComponent
        titleName={'WebRTCComponent'}
        showing={showWebRTC}
        handleHide={handleCloseWebRTC}
      /> */}
    </div>
  );
}

export default App;
